// hooks/useTheme.js
import {useCallback} from 'react';
import useZustandStore from "./useZustandStore";

export const useTheme = () => {
    const updateSetting = useZustandStore((state) => state.updateSetting);

    const setTheme = useCallback(({paper, ink, paperWarm, paperDeep, paperShadow, label}) => {
        // 更新 store 中的主题标签
        updateSetting('themeLabel', label);
        // 注入 CSS 变量（与之前相同）
        let style = document.getElementById('theme-vars');
        if (!style) {
            style = document.createElement('style');
            style.id = 'theme-vars';
            document.head.appendChild(style);
        }
        style.textContent = `
        :root {
          --tw-paper: ${paper};
          --tw-paper-warm: ${paperWarm};
          --tw-paper-deep: ${paperDeep};
          --tw-paper-shadow: ${paperShadow};
          --tw-ink: ${ink};
        }
        .bg-paper { background-color: ${paper} !important; }
        .bg-paper-warm { background-color: ${paperWarm} !important; }
        .bg-paper-deep, .hover\\:bg-paper-deep:hover { background-color: ${paperDeep} !important; }
        .border-paper-deep { border-color: ${paperDeep} !important; }
        .text-ink { color: ${ink} !important; }
        .bg-paper\\/95 { background-color: ${paper}f2 !important; }
        .text-paper-warm { color: ${paper} !important; }
        main { background-color: ${paper} !important; }
      `;
    }, [updateSetting]);

    return {setTheme};
};
